import React, { useState } from 'react'
import './qualification.css'
import {
  HiOutlineAcademicCap,
  HiOutlineBriefcase,
  HiOutlineCalendar,
} from 'react-icons/hi'
import { BsBoxArrowUpRight } from 'react-icons/bs'

const Qualification = () => {
  const [toggleState, setToggleState] = useState(1)

  const toggleTab = (index) => {
    setToggleState(index)
  }

  return (
    <section className="qualification section">
      <h2 className="section__title">Qualification</h2>
      <span className="section__subtitle">My Journey</span>

      <div className="qualification__container container">
        <div className="qualification__tabs">
          <div
            className={
              toggleState === 1
                ? 'qualification__button button--flex qualification__active'
                : 'qualification__button button--flex'
            }
            onClick={() => toggleTab(1)}
          >
            <HiOutlineAcademicCap className="qualification__icon" />
            Education
          </div>
          <div
            className={
              toggleState === 2
                ? 'qualification__button button--flex qualification__active'
                : 'qualification__button button--flex'
            }
            onClick={() => toggleTab(2)}
          >
            <HiOutlineBriefcase className="qualification__icon" />
            Experience
          </div>
        </div>

        <div className="qualification__sections">
          <div
            className={
              toggleState === 1
                ? 'qualification__content qualification__content-active'
                : 'qualification__content'
            }
          >
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">1st-4th Grad</h3>
                <span className="qualification__subtitle">
                  Ekalavya Primary School, Bidar
                </span>
                <div className="qualification__calendar">
                  <HiOutlineCalendar className="qualification__calendar-icon" />
                  2008-2012
                </div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
            <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">5th-10th Grad</h3>
                <span className="qualification__subtitle">
                  Raveendra High School, Bidar
                </span>
                <div className="qualification__calendar">
                  <HiOutlineCalendar className="qualification__calendar-icon" />
                  2012-2018
                </div>
              </div>
            </div>
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Inter 1st and 2nd year</h3>
                <span className="qualification__subtitle">
                  Sri Chaitanya Junior College, Hyderabad
                </span>
                <div className="qualification__calendar">
                  <HiOutlineCalendar className="qualification__calendar-icon" />
                  2021-2022
                </div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
            <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">B.Tech, CSE</h3>
                <span className="qualification__subtitle">
                  PES University, Bangalore
                </span>
                <div className="qualification__calendar">
                  <HiOutlineCalendar className="qualification__calendar-icon" />
                  2021-2025
                </div>
              </div>
            </div>
          </div>
          <div
            className={
              toggleState === 2
                ? 'qualification__content qualification__content-active'
                : 'qualification__content'
            }
          >
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">SDE-1</h3>
                <span className="qualification__subtitle">
                  <a
                    href="https://udaan.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Udaan <BsBoxArrowUpRight className="arrow_icon" />
                  </a>
                  <br />
                  Internship (On-Site)
                </span>
                <div className="qualification__calendar">
                  <HiOutlineCalendar className="qualification__calendar-icon" />
                  Jan 2025 - Jul 2025<br/>(6 months)
                </div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
            <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">Full Stack Developer</h3>
                <span className="qualification__subtitle">
                  <a
                    href="https://alaiy.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Alaiy <BsBoxArrowUpRight className="arrow_icon" />
                  </a>
                  <br />
                  Freelancer
                </span>
                <div className="qualification__calendar">
                  <HiOutlineCalendar className="qualification__calendar-icon" />
                  Nov 2024 - Dec 2024 (1 months)
                </div>
              </div>
            </div>
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Full Stack Developer</h3>
                <span className="qualification__subtitle">
                  <a
                    href="https://greentick.me/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    GreenTick <BsBoxArrowUpRight className="arrow_icon" />
                  </a>
                  <br />
                  Internship (Hybrid)
                </span>
                <div className="qualification__calendar">
                  <HiOutlineCalendar className="qualification__calendar-icon" />
                  Apr 2023 - Sept 2023 (6 months)
                </div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
            <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">CTO</h3>
                <span className="qualification__subtitle">
                  <a
                    href="https://iotforhire.vercel.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    IoTforHire <BsBoxArrowUpRight className="arrow_icon" />
                  </a>
                  <br />
                  Full-Time (On-Site)
                </span>
                <div className="qualification__calendar">
                  <HiOutlineCalendar className="qualification__calendar-icon" />
                  Mar 2023 - Aug 2023 (6 months)
                </div>
              </div>
            </div>
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Product Developer</h3>
                <span className="qualification__subtitle">
                  <a
                    href="https://www.pesuventurelabs.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    PESU Venture Labs{' '}
                    <BsBoxArrowUpRight className="arrow_icon" />
                  </a>
                  <br /> Internship (Hybrid)
                </span>
                <div className="qualification__calendar">
                  <HiOutlineCalendar className="qualification__calendar-icon" />
                  Apr 2023 - dec 2023 (9 months)
                </div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Qualification
